import type { PlainAction } from '@components/types';
import { useModalDispatch } from '@hooks/useModalProvider';
import { useDataIsEmpty } from '@pages/User/hooks';
import { useAllTeams } from '@queries/fetchTeams';
import { MODALS } from '@src/constants';

import type { TeamRecord } from '../types';
import { UserTeams } from '../views/UserTeams';

export const UserTeamsController = () => {
  const { showModal } = useModalDispatch();
  const { data, status } = useAllTeams();
  const teams = (data ?? []) as TeamRecord[];
  const isEmpty = useDataIsEmpty(teams, status);

  const createAction: PlainAction = {
    key: 'create',
    label: 'New Team',
    onClick: () => showModal(MODALS.TEAM_FORM, {}),
  };

  return (
    <UserTeams
      createAction={createAction}
      isEmpty={isEmpty}
      onEdit={(team: TeamRecord) => showModal(MODALS.TEAM_FORM, { team })}
      status={status}
      teams={teams}
    />
  );
};
